import { getActiveProviderCode } from './config'
import { getAdapter } from './registry'
import type { InventoryItem, InventoryItemPage } from './types'

export const inventoryService = {
  async listCompositeItems(params: { cursor?: string } = {}): Promise<InventoryItemPage> {
    const adapter = getAdapter(await getActiveProviderCode())
    if (!adapter) throw new Error('No active inventory adapter')
    return adapter.listCompositeItems(params)
  },

  async listAllItems(params: { cursor?: string } = {}): Promise<InventoryItemPage> {
    const adapter = getAdapter(await getActiveProviderCode())
    if (!adapter) throw new Error('No active inventory adapter')
    if (adapter.listAllItems) {
      return adapter.listAllItems(params)
    }
    // Fallback: if not implemented, return empty list to avoid breaking UI
    return { items: [], nextCursor: undefined }
  },

  async getItemById(id: string, options?: { kind?: 'item' | 'composite' }): Promise<InventoryItem> {
    const adapter = getAdapter(await getActiveProviderCode())
    if (!adapter) throw new Error('No active inventory adapter')
    return adapter.getItemById(id, options)
  },

  async getStockLevels(ids: string[]): Promise<Record<string, number>> {
    const adapter = getAdapter(await getActiveProviderCode())
    if (!adapter) throw new Error('No active inventory adapter')
    return adapter.getStockLevels(ids)
  },
}

